import {
	useEffect, useState,
} from 'react';

enum Status {
  ONLINE = 'online',
  OFFLINE = 'offline'
}

export const useOnline = (): boolean => {
	const [isOnline, setIsOnline] = useState(window.navigator.onLine);

	const setIsOffline = () => setIsOnline(false);
	const setIsOnlineNow = () => setIsOnline(true);

	useEffect(() => {
		window.addEventListener(
			Status.OFFLINE,
			setIsOffline
		);
		window.addEventListener(
			Status.ONLINE,
			setIsOnlineNow
		);

		// Remove event listener on cleanup
		return () => {
			window.removeEventListener(Status.OFFLINE, setIsOffline);
			window.removeEventListener(Status.ONLINE, setIsOnlineNow);
		};
	}, []); // Empty array ensures that effect is only run on mount

	return isOnline;
};